import { Case, SceneObject, Evidence, Movement } from '../types';

// Case data
export const cases: Case[] = [
  {
    id: 'case3',
    caseNumber: 'CS-2024-003',
    title: 'Restaurant Party Investigation',
    description: 'Complex investigation involving 6 families at a restaurant party with multiple transport methods and locations',
    date: '2024-07-20'
  },
  {
    id: 'case1',
    caseNumber: 'CS-2024-001',
    title: 'Marina Bay Sands Homicide',
    description: 'Investigation into the murder of Alice Ng at Marina Bay Sands Hotel',
    date: '2024-06-01'
  },
  {
    id: 'case2',
    caseNumber: 'CS-2024-002',
    title: 'Orchard Road Robbery',
    description: 'Armed robbery investigation at luxury retail stores',
    date: '2024-06-15'
  }
];

// Initial scene objects with evidence and person images
export const initialSceneObjects: SceneObject[] = [
  // Case 3: Restaurant Party Investigation - 6 Families
  // Family 1: Tan Family (from Tampines, MRT + Bus)
  {
    id: 'party1',
    name: 'Mr. Tan Wei Ming',
    type: 'person',
    people: ['Mr. Tan Wei Ming'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Tampines MRT Station', lat: 1.3526, lng: 103.9454 }
    },
    time: '2024-07-20T17:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party2',
    name: 'Mrs. Tan Li Hua',
    type: 'person',
    people: ['Mrs. Tan Li Hua'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Tampines MRT Station', lat: 1.3526, lng: 103.9454 }
    },
    time: '2024-07-20T17:30:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party3',
    name: 'Tan Family',
    type: 'person',
    people: ['Mr. Tan Wei Ming', 'Mrs. Tan Li Hua'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown MRT Station', lat: 1.2847, lng: 103.8444 }
    },
    time: '2024-07-20T18:15:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party4',
    name: 'Tan Family',
    type: 'person',
    people: ['Mr. Tan Wei Ming', 'Mrs. Tan Li Hua'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  // Family 2: Lim Family (from Jurong West, Car)
  {
    id: 'party5',
    name: 'Mr. Lim Ah Keng',
    type: 'person',
    people: ['Mr. Lim Ah Keng'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Jurong West Car Park', lat: 1.3404, lng: 103.7053 }
    },
    time: '2024-07-20T17:45:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party6',
    name: 'Mrs. Lim Mei Ling',
    type: 'person',
    people: ['Mrs. Lim Mei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Jurong West Car Park', lat: 1.3404, lng: 103.7053 }
    },
    time: '2024-07-20T17:45:00',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party7',
    name: 'Lim Family',
    type: 'person',
    people: ['Mr. Lim Ah Keng', 'Mrs. Lim Mei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:20:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },

  // Family 3: Wong Family (from Bedok, Taxi)
  {
    id: 'party8',
    name: 'Mr. Wong Chee Meng',
    type: 'person',
    people: ['Mr. Wong Chee Meng'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Bedok Taxi Stand', lat: 1.3239, lng: 103.9301 }
    },
    time: '2024-07-20T17:50:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party9',
    name: 'Mrs. Wong Siew Mei',
    type: 'person',
    people: ['Mrs. Wong Siew Mei'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Bedok Taxi Stand', lat: 1.3239, lng: 103.9301 }
    },
    time: '2024-07-20T17:50:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party10',
    name: 'Wong Family',
    type: 'person',
    people: ['Mr. Wong Chee Meng', 'Mrs. Wong Siew Mei'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:25:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },

  // Family 4: Chen Family (from Woodlands, Grab)
  {
    id: 'party11',
    name: 'Mr. Chen Boon Kiat',
    type: 'person',
    people: ['Mr. Chen Boon Kiat'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Woodlands Grab Pickup', lat: 1.4360, lng: 103.7860 }
    },
    time: '2024-07-20T17:40:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party12',
    name: 'Mrs. Chen Ai Lin',
    type: 'person',
    people: ['Mrs. Chen Ai Lin'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Woodlands Grab Pickup', lat: 1.4360, lng: 103.7860 }
    },
    time: '2024-07-20T17:40:00',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party13',
    name: 'Chen Family',
    type: 'person',
    people: ['Mr. Chen Boon Kiat', 'Mrs. Chen Ai Lin'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:35:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  // Family 5: Lee Family (from Pasir Ris, Bus)
  {
    id: 'party14',
    name: 'Mr. Lee Seng Chuan',
    type: 'person',
    people: ['Mr. Lee Seng Chuan'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Pasir Ris Bus Interchange', lat: 1.3724, lng: 103.9494 }
    },
    time: '2024-07-20T17:35:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party15',
    name: 'Mrs. Lee Pei Ling',
    type: 'person',
    people: ['Mrs. Lee Pei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Pasir Ris Bus Interchange', lat: 1.3724, lng: 103.9494 }
    },
    time: '2024-07-20T17:35:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party16',
    name: 'Lee Family',
    type: 'person',
    people: ['Mr. Lee Seng Chuan', 'Mrs. Lee Pei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:40:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },

  // Family 6: Ng Family (from Sengkang, MRT)
  {
    id: 'party17',
    name: 'Mr. Ng Teck Hock',
    type: 'person',
    people: ['Mr. Ng Teck Hock'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Sengkang MRT Station', lat: 1.3916, lng: 103.8950 }
    },
    time: '2024-07-20T17:55:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party18',
    name: 'Mrs. Ng Hui Min',
    type: 'person',
    people: ['Mrs. Ng Hui Min'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Sengkang MRT Station', lat: 1.3916, lng: 103.8950 }
    },
    time: '2024-07-20T17:55:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party19',
    name: 'Ng Family',
    type: 'person',
    people: ['Mr. Ng Teck Hock', 'Mrs. Ng Hui Min'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:45:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  // All families at restaurant
  {
    id: 'party20',
    name: 'All Families',
    type: 'person',
    people: ['Mr. Tan Wei Ming', 'Mrs. Tan Li Hua', 'Mr. Lim Ah Keng', 'Mrs. Lim Mei Ling', 'Mr. Wong Chee Meng', 'Mrs. Wong Siew Mei', 'Mr. Chen Boon Kiat', 'Mrs. Chen Ai Lin', 'Mr. Lee Seng Chuan', 'Mrs. Lee Pei Ling', 'Mr. Ng Teck Hock', 'Mrs. Ng Hui Min'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Restaurant Dining Area', x: 3, y: 4, z: 1, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T19:00:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  // Post-dinner drinks at Clarke Quay
  {
    id: 'party21',
    name: 'Tan Family',
    type: 'person',
    people: ['Mr. Tan Wei Ming', 'Mrs. Tan Li Hua'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    time: '2024-07-20T21:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party22',
    name: 'Lim Family',
    type: 'person',
    people: ['Mr. Lim Ah Keng', 'Mrs. Lim Mei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    time: '2024-07-20T21:30:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party23',
    name: 'Wong Family',
    type: 'person',
    people: ['Mr. Wong Chee Meng', 'Mrs. Wong Siew Mei'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    time: '2024-07-20T21:30:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party24',
    name: 'Chen Family',
    type: 'person',
    people: ['Mr. Chen Boon Kiat', 'Mrs. Chen Ai Lin'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    time: '2024-07-20T21:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party25',
    name: 'Lee Family',
    type: 'person',
    people: ['Mr. Lee Seng Chuan', 'Mrs. Lee Pei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    time: '2024-07-20T21:30:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party26',
    name: 'Ng Family',
    type: 'person',
    people: ['Mr. Ng Teck Hock', 'Mrs. Ng Hui Min'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    time: '2024-07-20T21:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  // Return journeys - different transport methods
  {
    id: 'party27',
    name: 'Tan Family',
    type: 'person',
    people: ['Mr. Tan Wei Ming', 'Mrs. Tan Li Hua'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Tampines MRT Station', lat: 1.3526, lng: 103.9454 }
    },
    time: '2024-07-20T23:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party28',
    name: 'Lim Family',
    type: 'person',
    people: ['Mr. Lim Ah Keng', 'Mrs. Lim Mei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Jurong West Car Park', lat: 1.3404, lng: 103.7053 }
    },
    time: '2024-07-20T23:45:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party29',
    name: 'Wong Family',
    type: 'person',
    people: ['Mr. Wong Chee Meng', 'Mrs. Wong Siew Mei'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Bedok Taxi Stand', lat: 1.3239, lng: 103.9301 }
    },
    time: '2024-07-20T23:15:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party30',
    name: 'Chen Family',
    type: 'person',
    people: ['Mr. Chen Boon Kiat', 'Mrs. Chen Ai Lin'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Woodlands Grab Pickup', lat: 1.4360, lng: 103.7860 }
    },
    time: '2024-07-20T23:20:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party31',
    name: 'Lee Family',
    type: 'person',
    people: ['Mr. Lee Seng Chuan', 'Mrs. Lee Pei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Pasir Ris Bus Interchange', lat: 1.3724, lng: 103.9494 }
    },
    time: '2024-07-20T23:35:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'party32',
    name: 'Ng Family',
    type: 'person',
    people: ['Mr. Ng Teck Hock', 'Mrs. Ng Hui Min'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Sengkang MRT Station', lat: 1.3916, lng: 103.8950 }
    },
    time: '2024-07-20T23:40:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  // Original cases data
  {
    id: '1',
    name: 'Detective Sarah Chen',
    type: 'person',
    people: ['Detective Sarah Chen'],
    category: 'Home Team',
    caseId: 'case1',
    location: {
      mode: 'global',
      global: { name: 'Marina Bay Sands', lat: 1.2838, lng: 103.8591 }
    },
    time: '2024-06-01T21:00:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '2',
    name: 'Person of Interest John Lim',
    type: 'person',
    people: ['Person of Interest John Lim'],
    category: 'Person of Interest',
    caseId: 'case1',
    location: {
      mode: 'global',
      global: { name: 'HDB Block 201B Punggol Field', lat: 1.4021, lng: 103.9078 }
    },
    time: '2024-06-01T22:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '3',
    name: 'Witness Maria Tan',
    type: 'person',
    people: ['Witness Maria Tan'],
    category: 'Other',
    caseId: 'case1',
    location: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    time: '2024-06-01T20:15:00',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '4',
    name: 'Security Guard David Wong',
    type: 'person',
    people: ['Security Guard David Wong'],
    category: 'Other',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Security Office', x: 5, y: 3, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T21:30:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '5',
    name: 'Victim Alice Ng',
    type: 'person',
    people: ['Victim Alice Ng'],
    category: 'Victim',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Room 403', x: 2, y: 4, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:00:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '6',
    name: 'Detective Sarah Chen',
    type: 'person',
    people: ['Detective Sarah Chen'],
    category: 'Home Team',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Room 403', x: 2, y: 4, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T23:15:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '7',
    name: 'Person of Interest John Lim',
    type: 'person',
    people: ['Person of Interest John Lim'],
    category: 'Person of Interest',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Kitchen', x: 3, y: 2, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:45:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '8',
    name: 'Witness Maria Tan',
    type: 'person',
    people: ['Witness Maria Tan'],
    category: 'Other',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Living Area', x: 4, y: 5, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T21:45:00',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
  },
  
  // Case 2 data
  {
    id: '9',
    name: 'Detective Michael Wong',
    type: 'person',
    people: ['Detective Michael Wong'],
    category: 'Home Team',
    caseId: 'case2',
    location: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    time: '2024-06-15T14:00:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '10',
    name: 'Person of Interest Alex Tan',
    type: 'person',
    people: ['Person of Interest Alex Tan'],
    category: 'Person of Interest',
    caseId: 'case2',
    location: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    time: '2024-06-15T14:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '11',
    name: 'Victim Sarah Lim',
    type: 'person',
    people: ['Victim Sarah Lim'],
    category: 'Victim',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Store Front', x: 2, y: 3, z: 1, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:15:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '12',
    name: 'Security Guard Robert Chen',
    type: 'person',
    people: ['Security Guard Robert Chen'],
    category: 'Other',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Security Office', x: 5, y: 2, z: 1, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:45:00',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '13',
    name: 'Witness David Kim',
    type: 'person',
    people: ['Witness David Kim'],
    category: 'Other',
    caseId: 'case2',
    location: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    time: '2024-06-15T14:20:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },

  // Duration events - People staying at restaurant for extended periods
  {
    id: 'duration1',
    name: 'Tan Family - Dining',
    type: 'person',
    people: ['Mr. Tan Wei Ming', 'Mrs. Tan Li Hua'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:15:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration2',
    name: 'Tan Family - Still Dining',
    type: 'person',
    people: ['Mr. Tan Wei Ming', 'Mrs. Tan Li Hua'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:45:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration3',
    name: 'Tan Family - Finishing Meal',
    type: 'person',
    people: ['Mr. Tan Wei Ming', 'Mrs. Tan Li Hua'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T19:15:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  {
    id: 'duration4',
    name: 'Lim Family - Dining',
    type: 'person',
    people: ['Mr. Lim Ah Keng', 'Mrs. Lim Mei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:20:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration5',
    name: 'Lim Family - Still Dining',
    type: 'person',
    people: ['Mr. Lim Ah Keng', 'Mrs. Lim Mei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:50:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration6',
    name: 'Lim Family - Finishing Meal',
    type: 'person',
    people: ['Mr. Lim Ah Keng', 'Mrs. Lim Mei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T19:20:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },

  {
    id: 'duration7',
    name: 'Wong Family - Dining',
    type: 'person',
    people: ['Mr. Wong Chee Meng', 'Mrs. Wong Siew Mei'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:25:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration8',
    name: 'Wong Family - Still Dining',
    type: 'person',
    people: ['Mr. Wong Chee Meng', 'Mrs. Wong Siew Mei'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:55:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration9',
    name: 'Wong Family - Finishing Meal',
    type: 'person',
    people: ['Mr. Wong Chee Meng', 'Mrs. Wong Siew Mei'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T19:25:00',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  },

  {
    id: 'duration10',
    name: 'Chen Family - Dining',
    type: 'person',
    people: ['Mr. Chen Boon Kiat', 'Mrs. Chen Ai Lin'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:40:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration11',
    name: 'Chen Family - Still Dining',
    type: 'person',
    people: ['Mr. Chen Boon Kiat', 'Mrs. Chen Ai Lin'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T19:10:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  {
    id: 'duration12',
    name: 'Lee Family - Dining',
    type: 'person',
    people: ['Mr. Lee Seng Chuan', 'Mrs. Lee Pei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:45:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration13',
    name: 'Lee Family - Still Dining',
    type: 'person',
    people: ['Mr. Lee Seng Chuan', 'Mrs. Lee Pei Ling'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T19:15:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },

  {
    id: 'duration14',
    name: 'Ng Family - Dining',
    type: 'person',
    people: ['Mr. Ng Teck Hock', 'Mrs. Ng Hui Min'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T19:05:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'duration15',
    name: 'Ng Family - Still Dining',
    type: 'person',
    people: ['Mr. Ng Teck Hock', 'Mrs. Ng Hui Min'],
    category: 'Person of Interest',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T19:25:00',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  }
];

// Evidence data
export const evidenceList: Evidence[] = [
  // Case 3: Restaurant Party Evidence
  {
    id: 'ev9',
    name: 'Restaurant CCTV Footage',
    description: 'Security camera recording showing all families entering and leaving the restaurant',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Restaurant Security Office', x: 1, y: 1, z: 1, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T19:00:00',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=150&h=150&fit=crop',
    type: 'Digital Evidence'
  },
  {
    id: 'ev10',
    name: 'Transport Receipts',
    description: 'Collection of taxi, Grab, and public transport receipts from all families',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Evidence Room', x: 2, y: 2, z: 1, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T18:30:00',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150&h=150&fit=crop',
    type: 'Document'
  },
  {
    id: 'ev11',
    name: 'Clarke Quay Bar Receipts',
    description: 'Drinks receipts from Clarke Quay showing all families present',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    time: '2024-07-20T21:30:00',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150&h=150&fit=crop',
    type: 'Document'
  },
  {
    id: 'ev12',
    name: 'MRT Card Records',
    description: 'EZ-Link card transaction records showing Tan and Ng families\' MRT journeys',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Tampines MRT Station', lat: 1.3526, lng: 103.9454 }
    },
    time: '2024-07-20T17:30:00',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150&h=150&fit=crop',
    type: 'Digital Evidence'
  },
  {
    id: 'ev13',
    name: 'Car Park Entry/Exit Records',
    description: 'Vehicle entry and exit records from Jurong West car park for Lim family',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Jurong West Car Park', lat: 1.3404, lng: 103.7053 }
    },
    time: '2024-07-20T17:45:00',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=150&h=150&fit=crop',
    type: 'Digital Evidence'
  },
  {
    id: 'ev14',
    name: 'Bus Journey Records',
    description: 'Bus journey records showing Lee family\'s trip from Pasir Ris',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Pasir Ris Bus Interchange', lat: 1.3724, lng: 103.9494 }
    },
    time: '2024-07-20T17:35:00',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150&h=150&fit=crop',
    type: 'Digital Evidence'
  },
  {
    id: 'ev15',
    name: 'Grab Ride Records',
    description: 'Grab ride booking and payment records for Chen family',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Woodlands Grab Pickup', lat: 1.4360, lng: 103.7860 }
    },
    time: '2024-07-20T17:40:00',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150&h=150&fit=crop',
    type: 'Digital Evidence'
  },
  {
    id: 'ev16',
    name: 'Taxi Meter Records',
    description: 'Taxi meter and payment records for Wong family\'s journey',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Bedok Taxi Stand', lat: 1.3239, lng: 103.9301 }
    },
    time: '2024-07-20T17:50:00',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150&h=150&fit=crop',
    type: 'Document'
  },

  // Original cases evidence
  {
    id: 'ev1',
    name: 'Bloody Knife',
    description: 'Kitchen knife found in victim\'s room with blood traces',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Room 403', x: 2, y: 4, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:00:00',
    image: 'https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=150&h=150&fit=crop',
    type: 'Weapon'
  },
  {
    id: 'ev2',
    name: 'Security Camera Footage',
    description: 'CCTV recording from hotel lobby showing suspect entry',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Security Office', x: 5, y: 3, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T21:30:00',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=150&h=150&fit=crop',
    type: 'Digital Evidence'
  },
  {
    id: 'ev3',
    name: 'Fingerprint on Door Handle',
    description: 'Partial fingerprint found on room door handle',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Room 403', x: 2, y: 4, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:00:00',
    image: 'https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=150&h=150&fit=crop',
    type: 'Fingerprint'
  },
  {
    id: 'ev4',
    name: 'Victim\'s Diary',
    description: 'Personal diary found in victim\'s belongings',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Room 403', x: 2, y: 4, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:00:00',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150&h=150&fit=crop',
    type: 'Document'
  },
  {
    id: 'ev5',
    name: 'Victim\'s Phone',
    description: 'Mobile phone found in victim\'s handbag',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Room 403', x: 2, y: 4, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:00:00',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150&h=150&fit=crop',
    type: 'Digital Evidence'
  },
  
  // Case 2 evidence
  {
    id: 'ev6',
    name: 'Stolen Jewelry',
    description: 'Diamond necklace and earrings found in suspect\'s possession',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Store Front', x: 2, y: 3, z: 1, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:15:00',
    image: 'https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=150&h=150&fit=crop',
    type: 'Stolen Property'
  },
  {
    id: 'ev7',
    name: 'Security Camera Footage',
    description: 'CCTV recording showing the robbery in progress',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Security Office', x: 5, y: 2, z: 1, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:15:00',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=150&h=150&fit=crop',
    type: 'Digital Evidence'
  },
  {
    id: 'ev8',
    name: 'Broken Glass',
    description: 'Shattered display case glass from the jewelry store',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Store Front', x: 2, y: 3, z: 1, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:15:00',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=150&h=150&fit=crop',
    type: 'Physical Evidence'
  }
];

// Movement data
export const movements: Movement[] = [
  // Case 3: Restaurant Party Movements
  
  // Tan Family Journey (MRT + Bus)
  {
    id: 'm6',
    person: 'Mr. Tan Wei Ming',
    fromLocation: {
      mode: 'global',
      global: { name: 'Tampines MRT Station', lat: 1.3526, lng: 103.9454 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Chinatown MRT Station', lat: 1.2847, lng: 103.8444 }
    },
    time: '2024-07-20T17:30:00'
  },
  {
    id: 'm7',
    person: 'Tan Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Chinatown MRT Station', lat: 1.2847, lng: 103.8444 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:15:00'
  },

  // Lim Family Journey (Car)
  {
    id: 'm8',
    person: 'Lim Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Jurong West Car Park', lat: 1.3404, lng: 103.7053 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T17:45:00'
  },

  // Wong Family Journey (Taxi)
  {
    id: 'm9',
    person: 'Wong Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Bedok Taxi Stand', lat: 1.3239, lng: 103.9301 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T17:50:00'
  },

  // Chen Family Journey (Grab)
  {
    id: 'm10',
    person: 'Chen Family',
    caseId: 'case3',
    fromLocation: {
      mode: 'global',
      global: { name: 'Woodlands Grab Pickup', lat: 1.4360, lng: 103.7860 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T17:40:00'
  },

  // Lee Family Journey (Bus)
  {
    id: 'm11',
    person: 'Lee Family',
    caseId: 'case3',
    fromLocation: {
      mode: 'global',
      global: { name: 'Pasir Ris Bus Interchange', lat: 1.3724, lng: 103.9494 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T17:35:00'
  },

  // Ng Family Journey (MRT)
  {
    id: 'm12',
    person: 'Ng Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Sengkang MRT Station', lat: 1.3916, lng: 103.8950 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T17:55:00'
  },

  // All families to Clarke Quay for drinks
  {
    id: 'm13',
    person: 'All Families',
    fromLocation: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    time: '2024-07-20T21:00:00'
  },

  // Return journeys - different transport methods
  {
    id: 'm14',
    person: 'Tan Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Tampines MRT Station', lat: 1.3526, lng: 103.9454 }
    },
    time: '2024-07-20T23:00:00'
  },
  {
    id: 'm15',
    person: 'Lim Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Jurong West Car Park', lat: 1.3404, lng: 103.7053 }
    },
    time: '2024-07-20T23:15:00'
  },
  {
    id: 'm16',
    person: 'Wong Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Bedok Taxi Stand', lat: 1.3239, lng: 103.9301 }
    },
    time: '2024-07-20T23:05:00'
  },
  {
    id: 'm17',
    person: 'Chen Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Woodlands Grab Pickup', lat: 1.4360, lng: 103.7860 }
    },
    time: '2024-07-20T23:10:00'
  },
  {
    id: 'm18',
    person: 'Lee Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Pasir Ris Bus Interchange', lat: 1.3724, lng: 103.9494 }
    },
    time: '2024-07-20T23:25:00'
  },
  {
    id: 'm19',
    person: 'Ng Family',
    fromLocation: {
      mode: 'global',
      global: { name: 'Clarke Quay', lat: 1.2888, lng: 103.8467 }
    },
    toLocation: {
      mode: 'global',
      global: { name: 'Sengkang MRT Station', lat: 1.3916, lng: 103.8950 }
    },
    time: '2024-07-20T23:30:00'
  },

  // Original cases movements
  {
    id: 'm1',
    person: 'Person of Interest John Lim',
    fromLocation: {
      mode: 'global',
      global: { name: 'HDB Block 201B Punggol Field', lat: 1.4021, lng: 103.9078 }
    },
    toLocation: {
      mode: 'local',
      local: { name: 'Kitchen', x: 3, y: 2, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:30:00'
  },
  {
    id: 'm2',
    person: 'Person of Interest John Lim',
    fromLocation: {
      mode: 'local',
      local: { name: 'Kitchen', x: 3, y: 2, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    toLocation: {
      mode: 'local',
      local: { name: 'Room 403', x: 2, y: 4, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:45:00'
  },
  {
    id: 'm3',
    person: 'Witness Maria Tan',
    fromLocation: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    toLocation: {
      mode: 'local',
      local: { name: 'Living Area', x: 4, y: 5, z: 1, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T21:30:00'
  },
  
  // Case 2 movements
  {
    id: 'm4',
    person: 'Person of Interest Alex Tan',
    fromLocation: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    toLocation: {
      mode: 'local',
      local: { name: 'Store Front', x: 2, y: 3, z: 1, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:15:00'
  },
  {
    id: 'm5',
    person: 'Detective Michael Wong',
    fromLocation: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    toLocation: {
      mode: 'local',
      local: { name: 'Security Office', x: 5, y: 2, z: 1, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:45:00'
  }
];

// Additional diverse people types for investigation
export const additionalSceneObjects: SceneObject[] = [
  // Home Team (Police/Investigators) - Case 1: Marina Bay Sands Homicide
  {
    id: 'ht1',
    name: 'Detective Inspector Raj Kumar',
    type: 'person',
    people: ['Detective Inspector Raj Kumar'],
    category: 'Home Team',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Living Room', x: 2, y: 2, z: 0, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T23:00:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht2',
    name: 'Forensic Specialist Dr. Emily Chen',
    type: 'person',
    people: ['Forensic Specialist Dr. Emily Chen'],
    category: 'Home Team',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Kitchen', x: 9, y: 4, z: 0, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T23:15:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht3',
    name: 'Police Officer Ahmad bin Ismail',
    type: 'person',
    people: ['Police Officer Ahmad bin Ismail'],
    category: 'Home Team',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Bedroom 1', x: 1, y: 9, z: 0, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T23:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht4',
    name: 'Sergeant Maria Rodriguez',
    type: 'person',
    people: ['Sergeant Maria Rodriguez'],
    category: 'Home Team',
    caseId: 'case1',
    location: {
      mode: 'global',
      global: { name: 'Marina Bay Sands', lat: 1.2868, lng: 103.8543 }
    },
    time: '2024-06-01T22:45:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },

  // Home Team - Case 2: Orchard Road Robbery
  {
    id: 'ht5',
    name: 'Detective Michael Wong',
    type: 'person',
    people: ['Detective Michael Wong'],
    category: 'Home Team',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Security Office', x: 5, y: 2, z: 0, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:45:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht6',
    name: 'Forensic Analyst James Tan',
    type: 'person',
    people: ['Forensic Analyst James Tan'],
    category: 'Home Team',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Store Front', x: 2, y: 3, z: 0, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T15:00:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht7',
    name: 'Police Constable Sarah Lim',
    type: 'person',
    people: ['Police Constable Sarah Lim'],
    category: 'Home Team',
    caseId: 'case2',
    location: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    time: '2024-06-15T14:30:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht8',
    name: 'Investigator David Kim',
    type: 'person',
    people: ['Investigator David Kim'],
    category: 'Home Team',
    caseId: 'case2',
    location: {
      mode: 'global',
      global: { name: 'Orchard Road Shopping District', lat: 1.3048, lng: 103.8318 }
    },
    time: '2024-06-15T14:15:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  // Home Team - Case 3: Restaurant Party Investigation
  {
    id: 'ht9',
    name: 'Detective Sergeant Lisa Wang',
    type: 'person',
    people: ['Detective Sergeant Lisa Wang'],
    category: 'Home Team',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Office', x: 17, y: 7, z: 0, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T19:00:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht10',
    name: 'Police Officer Robert Chen',
    type: 'person',
    people: ['Police Officer Robert Chen'],
    category: 'Home Team',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Dining Area 1', x: 1, y: 1, z: 0, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T19:15:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht11',
    name: 'Forensic Technician Alex Ng',
    type: 'person',
    people: ['Forensic Technician Alex Ng'],
    category: 'Home Team',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Kitchen', x: 1, y: 7, z: 0, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T19:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'ht12',
    name: 'Investigator Priya Singh',
    type: 'person',
    people: ['Investigator Priya Singh'],
    category: 'Home Team',
    caseId: 'case3',
    location: {
      mode: 'global',
      global: { name: 'Chinatown Restaurant', lat: 1.2838, lng: 103.8438 }
    },
    time: '2024-07-20T18:45:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },

  // Victims
  {
    id: 'v1',
    name: 'Victim Alice Ng',
    type: 'person',
    people: ['Victim Alice Ng'],
    category: 'Victim',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Bedroom 2', x: 13, y: 9, z: 0, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T22:00:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'v2',
    name: 'Victim Sarah Lim',
    type: 'person',
    people: ['Victim Sarah Lim'],
    category: 'Victim',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Store Front', x: 2, y: 3, z: 0, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:00:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },

  // Witnesses
  {
    id: 'w1',
    name: 'Witness Maria Tan',
    type: 'person',
    people: ['Witness Maria Tan'],
    category: 'Other',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Living Room', x: 4, y: 5, z: 0, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T21:30:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'w2',
    name: 'Witness David Kim',
    type: 'person',
    people: ['Witness David Kim'],
    category: 'Other',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Security Office', x: 5, y: 2, z: 0, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },

  // Restaurant staff for case 3
  {
    id: 'rs1',
    name: 'Restaurant Manager Mr. Zhang',
    type: 'person',
    people: ['Restaurant Manager Mr. Zhang'],
    category: 'Other',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Office', x: 17, y: 7, z: 0, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T18:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'rs2',
    name: 'Chef Li Wei',
    type: 'person',
    people: ['Chef Li Wei'],
    category: 'Other',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Kitchen', x: 1, y: 7, z: 0, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T18:30:00',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 'rs3',
    name: 'Waitress Jenny Wong',
    type: 'person',
    people: ['Waitress Jenny Wong'],
    category: 'Other',
    caseId: 'case3',
    location: {
      mode: 'local',
      local: { name: 'Dining Area 1', x: 1, y: 1, z: 0, parentLocation: 'Chinatown Restaurant' }
    },
    time: '2024-07-20T18:30:00',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  }
];

// Additional evidence with local locations
export const additionalEvidence: Evidence[] = [
  {
    id: 'ev_local_1',
    name: 'Blood Stain on Carpet',
    description: 'Blood stain found on living room carpet, appears to be from victim',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Living Room', x: 3, y: 3, z: 0, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T23:00:00',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=150&h=150&fit=crop',
    type: 'Biological Evidence',
    source: 'Forensic Team'
  },
  {
    id: 'ev_local_2',
    name: 'Broken Glass',
    description: 'Shattered glass fragments found near kitchen window',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Kitchen', x: 10, y: 5, z: 0, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T23:15:00',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=150&h=150&fit=crop',
    type: 'Physical Evidence',
    source: 'Forensic Team'
  },
  {
    id: 'ev_local_3',
    name: 'Fingerprint on Door Handle',
    description: 'Partial fingerprint found on bedroom door handle',
    caseId: 'case1',
    location: {
      mode: 'local',
      local: { name: 'Bedroom 1', x: 2, y: 10, z: 0, parentLocation: 'Marina Bay Sands' }
    },
    time: '2024-06-01T23:30:00',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=150&h=150&fit=crop',
    type: 'Fingerprint',
    source: 'Forensic Team'
  },
  {
    id: 'ev_local_4',
    name: 'Security Camera Footage',
    description: 'CCTV footage showing suspect entering the building',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Security Office', x: 6, y: 3, z: 0, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T14:45:00',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=150&h=150&fit=crop',
    type: 'Digital Evidence',
    source: 'CCTV System'
  },
  {
    id: 'ev_local_5',
    name: 'Stolen Jewelry',
    description: 'Expensive jewelry items found hidden in storage area',
    caseId: 'case2',
    location: {
      mode: 'local',
      local: { name: 'Store Front', x: 3, y: 4, z: 0, parentLocation: 'Orchard Road Shopping District' }
    },
    time: '2024-06-15T15:00:00',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=150&h=150&fit=crop',
    type: 'Stolen Property',
    source: 'Police Search'
  }
];

// Person colors for movement lines and markers (unique colors for each person)
export const personColors = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
  '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9',
  '#F8C471', '#82E0AA', '#F1948A', '#85C1E9', '#D7BDE2',
  '#FF9800', '#9C27B0', '#607D8B', '#795548', '#FF5722',
  '#E91E63', '#00BCD4', '#8BC34A', '#CDDC39', '#FFC107'
];

